<div [style]="'padding: ' + padding" class="series-headline">
  <hr class="label-hr" />
  @if (!!label) {
    <span class="label">{{ label | translate }}</span>
  }
  <hr class="label-hr" />
</div>
